

$(document).ready(function() {
    var hasDpdSuggestionMarkup = $('#invoiceAddressStreetSelectedFromSuggestion').length || $('#differentAddressStreetSelectedFromSuggestion').length;
    if (!hasDpdSuggestionMarkup) {
        return;
    }

    var invoiceAddressLocationSelector = '#invoiceAddress\\.town',
        invoiceAddressRegionSelector = '#invoiceAddress\\.regionName',
        invoiceAddressZipCodeSelector = '#invoiceAddress\\.postalCode',
        invoiceAddressStreetSelector = '#invoiceAddress\\.streetname',
        invoiceAddressCountryCodeSelector = '#invoice-country-isocode';
    var $invoiceAddressLocationField = $(invoiceAddressLocationSelector);
    var $invoiceAddressZipCodeField = $(invoiceAddressZipCodeSelector);
    var $invoiceAddressStreetField = $(invoiceAddressStreetSelector);
    var $invoiceAddressSelectedFromSuggestionField = $('#invoiceAddressStreetSelectedFromSuggestion');
    var invoiceAddressSuggestionService = undefined;
    if (($invoiceAddressLocationField.length || $invoiceAddressZipCodeField.length || $invoiceAddressStreetField.length)
        && $invoiceAddressSelectedFromSuggestionField.length) {
        invoiceAddressSuggestionService = new DpdAddressSuggestionService(invoiceAddressLocationSelector,
            invoiceAddressRegionSelector,
            invoiceAddressZipCodeSelector,
            invoiceAddressStreetSelector,
            invoiceAddressCountryCodeSelector,
            '#invoiceAddressStreetSelectedFromSuggestion',
            'invoice');
    }

    var differentAddressLocationSelector = '#differentAddress\\.town',
        differentAddressRegionSelector = '#differentAddress\\.regionName',
        differentAddressZipCodeSelector = '#differentAddress\\.postalCode',
        differentAddressStreetSelector = '#differentAddress\\.streetname';
    var $differentAddressLocationField = $(differentAddressLocationSelector);
    var $differentAddressZipCodeField = $(differentAddressZipCodeSelector);
    var $differentAddressStreetField = $(differentAddressStreetSelector);
    var $differentAddressSelectedFromSuggestionField = $('#differentAddressStreetSelectedFromSuggestion');
    var differentAddressSuggestionService = undefined;
    if (($differentAddressLocationField.length || $differentAddressZipCodeField.length || $differentAddressStreetField.length)
        && $differentAddressSelectedFromSuggestionField.length) {
        differentAddressSuggestionService = new DpdAddressSuggestionService(differentAddressLocationSelector,
            differentAddressRegionSelector,
            differentAddressZipCodeSelector,
            differentAddressStreetSelector,
            undefined,
            '#differentAddressStreetSelectedFromSuggestion',
            'different');
    }

    /*LOCATION*/
    if (invoiceAddressSuggestionService !== undefined) {
        $invoiceAddressLocationField.on("keyup", function() {
            invoiceAddressSuggestionService.handleLocationFieldKeyUp();
        });

        $invoiceAddressLocationField.on("focus", function() {
            invoiceAddressSuggestionService.handleLocationFieldFocus();
        });

        $invoiceAddressLocationField.on("focusout", function() {
            invoiceAddressSuggestionService.handleLocationFieldFocusOut();
        });
    }

    if (differentAddressSuggestionService !== undefined) {
        $differentAddressLocationField.on("keyup", function () {
            differentAddressSuggestionService.handleLocationFieldKeyUp();
        });

        $differentAddressLocationField.on("focus", function () {
            differentAddressSuggestionService.handleLocationFieldFocus();
        });

        $differentAddressLocationField.on("focusout", function () {
            differentAddressSuggestionService.handleLocationFieldFocusOut();
        });
    }

    /*ZIP CODE*/
    if (invoiceAddressSuggestionService !== undefined) {
        $invoiceAddressZipCodeField.on("keyup", function () {
            invoiceAddressSuggestionService.handleZipCodeFieldKeyUp();
        });

        $invoiceAddressZipCodeField.on("focus", function () {
            invoiceAddressSuggestionService.handleZipCodeFieldFocus();
        });

        $invoiceAddressZipCodeField.on("focusout", function () {
            invoiceAddressSuggestionService.handleZipCodeFieldFocusOut();
        });
    }

    if (differentAddressSuggestionService !== undefined) {
        $differentAddressZipCodeField.on("keyup", function () {
            differentAddressSuggestionService.handleZipCodeFieldKeyUp();
        });

        $differentAddressZipCodeField.on("focus", function () {
            differentAddressSuggestionService.handleZipCodeFieldFocus();
        });

        $differentAddressZipCodeField.on("focusout", function () {
            differentAddressSuggestionService.handleZipCodeFieldFocusOut();
        });
    }

    /*STREET*/
    if (invoiceAddressSuggestionService !== undefined) {
        $invoiceAddressStreetField.on("keyup", function () {
            invoiceAddressSuggestionService.handleStreetFieldKeyUp();
        });

        $invoiceAddressStreetField.on("focus", function () {
            invoiceAddressSuggestionService.handleStreetFieldFocus();
        });

        $invoiceAddressStreetField.on("focusout", function () {
            invoiceAddressSuggestionService.handleStreetFieldFocusOut();
        });
    }

    if (differentAddressSuggestionService !== undefined) {
        $differentAddressStreetField.on("keyup", function () {
            differentAddressSuggestionService.handleStreetFieldKeyUp();
        });

        $differentAddressStreetField.on("focus", function () {
            differentAddressSuggestionService.handleStreetFieldFocus();
        });

        $differentAddressStreetField.on("focusout", function () {
            differentAddressSuggestionService.handleStreetFieldFocusOut();
        });
    }



    if (invoiceAddressSuggestionService !== undefined || differentAddressSuggestionService !== undefined) {
        $(document).on("mouseup", function(event) {
            if (invoiceAddressSuggestionService !== undefined) {
                invoiceAddressSuggestionService.togglePopup(event);
            }
            if (differentAddressSuggestionService !== undefined) {
                differentAddressSuggestionService.togglePopup(event);
            }
        });

        $(document).on("keydown", function(event) {
            if (invoiceAddressSuggestionService !== undefined) {
                invoiceAddressSuggestionService.togglePopupSelect(event);
            }
            if (differentAddressSuggestionService !== undefined) {
                differentAddressSuggestionService.togglePopupSelect(event);
            }
        });
    }
});